<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: DropZoneList
 */
import type { DropZoneListProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DropZoneList',
})

withDefaults(defineProps<DropZoneListProps>(), {
  title: '',
  error: '',
})
</script>

<template>
  <div class="drop-zone-list">
    <AppText
      v-if="title"
      name="body1"
      color="slate-900"
      class="drop-zone-list__title"
    >
      {{ title }}
    </AppText>
    <div class="drop-zone-list__body">
      <slot />
    </div>
    <AppText
      v-if="error"
      name="body2-medium"
      color="red-600"
      class="drop-zone-list__error"
    >
      {{ error }}
    </AppText>
  </div>
</template>

<style lang="scss" scoped src="../styles/_drop-zone-list.scss" />
